import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";
import { API_URL, colorPrimary, colorSecondory, Report_URL, Rresource_Path } from "../../constants";
import { useAuth } from "react-oidc-context";
import { Button, Checkbox, DatePicker, Radio, Select, SelectProps, Space, Table, Tag } from "antd";
import { ChartStaticsDto, Configuration, ConfigurationParameters, DocumentApi, DocumentStatusDetailsReportDto, ItemApi, LocationGroupApi, PartyApi, PartyDto, ReportApi, ReportFilterDto } from "../../api/najd";
import Title from "antd/es/typography/Title";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { ColumnsType } from "antd/lib/table/interface";
import MyPieChart from "../../components/PieChart";
import { getFullDateTime } from "../../helper";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
const { RangePicker } = DatePicker;

export default () => {

  const { t, i18n } = useTranslation();
  const [data, setData] = useState<ChartStaticsDto[]>([]);
  const [data_gender_recived, set_data_gender_recived] = useState<ChartStaticsDto[]>([]);
  const [data_table, setdata_table] = useState<DocumentStatusDetailsReportDto[]>([]);
  const auth = useAuth();
  const [showOnlyActiveItem, setShowOnlyActiveItem] = useState<boolean>(false);

  const token = auth.user?.access_token;
  const configParameters: ConfigurationParameters = {
    basePath: API_URL,
    accessToken: token,
    baseOptions: {
      headers: { Authorization: 'Bearer ' + token },
    }
  };
  const configuration = new Configuration(configParameters);
  const reportApi = new ReportApi(configuration);

  const locationGroupApi = new LocationGroupApi(configuration);

  /***end get options */

  const columns: ColumnsType<DocumentStatusDetailsReportDto> = [
    {
      title: 'رقم الطلب',
      dataIndex: 'key',
      key: 'key',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'المريض',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'المورد',
      dataIndex: 'supplier',
      key: 'supplier',
    },
    {
      title: 'تاريخ فتح الطلب',
      dataIndex: 'requestDate',
      key: 'requestDate', render: ((date: string) => getFullDateTime(date))
    },
    {
      title: 'تاريخ اخر تعديل',
      dataIndex: 'requestUpdateDate',
      key: 'requestUpdateDate', render: ((date: string) => getFullDateTime(date))
    },

    {
      title: 'الملفات',
      dataIndex: 'key',
      key: 'key',
      render: (valu, record) => <>
        {record.file1 != null ? <a href={`${Rresource_Path}${record.file1}`} target="_blank" rel="noopener noreferrer">{t('Download File')} 1</a> : 'N/A 1'} |
        {record.file2 != null ? <a href={`${Rresource_Path}${record.file2}`} target="_blank" rel="noopener noreferrer">{t('Download File')} 2</a> : 'N/A 2'} |
        {record.file3 != null ? <a href={`${Rresource_Path}${record.file3}`} target="_blank" rel="noopener noreferrer">{t('Download File')} 3</a> : 'N/A 3'} |
        {record.file4 != null ? <a href={`${Rresource_Path}${record.file4}`} target="_blank" rel="noopener noreferrer">{t('Download File')} 4</a> : 'N/A 4'}
      </>
      ,
    },
    {
      title: 'الحالة',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'حالة التسليم',
      key: 'statusCode',
      dataIndex: 'statusCode',
      render: (_, { statusCode }) => {
        let color = statusCode !== 'Delivered' ? 'red' : 'green';

        return (
          <Tag color={color} key={statusCode}>
            {t(statusCode ?? '')}
          </Tag>
        );
      },
    },
  ];

  const [selectedDateRange, setSelectedDateRange] = useState<[string, string] | null>(null);
  const [locationGrouplist, setlocationGrouplist] = useState<SelectProps['options']>([]);
  const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
  const [selectedStatus, set_selectedStatus] = useState<string | null>(null);

  const handleDateRangeChange = (dates: any, dateStrings: [string, string]) => {
    setSelectedDateRange(dateStrings);
  };

  useEffect(() => {
    if (selectedDateRange != null) {
      getData();
      getDataTable();
    }
  }, [selectedDateRange, showOnlyActiveItem, selectedLocation, selectedStatus]); // Run this effect only once when the component mounts

  useEffect(() => {

    fetchlocationGroups()
      .then((response) => {
        var mapedOptions: SelectProps['options'] = response?.map(({ name, code }) => (
          {
            label: name,
            value: code
          }
        ));
        setlocationGrouplist(mapedOptions);
      })
      .catch((error) => {
        console.error('Failed to fetch select options:', error);
        setlocationGrouplist([]);
      });

  }, []);

  const fetchlocationGroups = () => {
    // Implement your API call here
    // Return a Promise that resolves with the options data
    return locationGroupApi.locationGroupGetList()
      .then((response) => response.data)
      .then((data) => data.items);
  };

  const getData = () => {
    const reportFilterDto: ReportFilterDto = {
      fromDate: dayjs(selectedDateRange![0]).format('YYYY-MM-DD'),
      toDate: dayjs(selectedDateRange![1]).format('YYYY-MM-DD'),
      locationGroup: selectedLocation
    };
    reportApi.reportDocumentStatusReport(
      reportFilterDto
    )
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch select options:', error);
      });


    const reportFilterDto_recived: ReportFilterDto = {
      fromDate: dayjs(selectedDateRange![0]).format('YYYY-MM-DD'),
      toDate: dayjs(selectedDateRange![1]).format('YYYY-MM-DD'),
      locationGroup: selectedLocation
    };
    reportApi.reportDocumentStatusReportGender(
      reportFilterDto_recived
    )
      .then((response) => {
        set_data_gender_recived(response.data);
      })
      .catch((error) => {
        console.error('Failed to fetch select options:', error);
      });

  };

  const getDataTable = () => {
    const reportFilterDto: ReportFilterDto = {
      fromDate: dayjs(selectedDateRange![0]).format('YYYY-MM-DD'),
      toDate: dayjs(selectedDateRange![1]).format('YYYY-MM-DD'),
      locationGroup: selectedLocation
    };
    reportApi.reportDocumentStatusDetailsReport(
      reportFilterDto
    )
      .then((response) => {
        var result_data = response.data;
        // if (selectedLocation != null) {
        //   result_data = result_data.filter(x => x.locationGroupCode === selectedLocation);
        // }
        if (selectedStatus != null) {
          result_data = result_data.filter(x => x.statusCode === selectedStatus);
        }
        setdata_table(result_data);
      })
      .catch((error) => {
        console.error('Failed to fetch select options:', error);
      });
  };

  const onChangeShowOnlyActiveItem = (e: CheckboxChangeEvent) => {
    setShowOnlyActiveItem(e.target.checked);
  };

  const handleLocationChange = (value: string) => {
    setSelectedLocation(value);
  };


  const onClickExportToPdf = () => {
    const reportFilterDto = {
      locationGroup: selectedLocation,
      fromDate: dayjs(selectedDateRange![0]).format('YYYY-MM-DD'),
      toDate: dayjs(selectedDateRange![1]).format('YYYY-MM-DD'),
      report_name: 'تفصيلي حالة الطلبات المسجلة'
    };
    const url: string = `${Report_URL}/Report/ExportRequestDetails?fromDate=${reportFilterDto.fromDate ?? ''}&toDate=${reportFilterDto.toDate ?? ''}&status=${selectedStatus ?? ''}&locationGroup=${reportFilterDto.locationGroup ?? ''}&report_name=${reportFilterDto.report_name ?? ''}&format=pdf&fileName=report`;
    const newTab = window.open(url, '_blank');
    if (newTab) {
      newTab.focus();
    } else {
      // If the new tab was blocked by the browser's popup blocker,
      // you can provide a fallback or display an error message.
      console.error('Failed to open new tab. Please allow popups for this site.');
    }
  }

  return (
    <div style={{ width: '100%', height: 1100 }}>
      <div style={{ width: '100%' }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Title level={5}>{t('Date Range')}</Title>
          <RangePicker
            style={{ minWidth: '300px' }}
            direction={i18n.dir()}
            // picker="month"
            // value={[dayjs('2023-01-01', 'YYYY-MM-DD'), dayjs('2023-12-31', 'YYYY-MM-DD')]}
            placeholder={[t("From Date"), t("To Date")]}
            onChange={handleDateRangeChange}
          />
          {/* <Checkbox value={showOnlyActiveItem} checked={showOnlyActiveItem} onChange={onChangeShowOnlyActiveItem}>{t("عرض الموقوف و المرفوض")}</Checkbox> */}


          <Title level={5}>{t('المركز')}</Title>
          <Select
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
            }
            onChange={handleLocationChange}
            options={locationGrouplist}
            placeholder={t("اختر المركز")}
            style={{ minWidth: '600px' }}
            allowClear
          />

          <Radio.Group defaultValue={selectedStatus} buttonStyle="solid" >
            <Radio.Button value={null} onClick={() => { set_selectedStatus(null); }}>{t("All")}</Radio.Button>
            <Radio.Button value="Delivered" onClick={() => { set_selectedStatus("Delivered"); }}>{t("Delivered")}</Radio.Button>
            <Radio.Button value="Not Delivered" onClick={() => { set_selectedStatus("Not Delivered"); }}>{t("Not Delivered")}</Radio.Button>
          </Radio.Group>
        </Space>
      </div>
      <div style={{ width: '100%', height: 300 }}>
        <h2 style={{ textAlign: "center" }}>تفصيلي حالة الطلبات المسجلة</h2>
        <div style={{ display: "flex", width: "100%", height: "100%" }}>
          <div style={{ flex: 1, height: "100%" }}>

            <MyPieChart
              title="حالة الطلبات المسجلة"
              localize={true}
              data={data} />
          </div>
          <div style={{ flex: 1, height: "100%" }}>

            <MyPieChart
            title="جنس المتسلم"
              localize={true}
              data={data_gender_recived} />
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <div style={{ width: '100%', height: 500 }}>
        <Button key="3" type="primary" onClick={() => onClickExportToPdf()}>
          {t("تصدير الى PDF")}
        </Button>

        <Table
          direction={i18n.dir()} columns={columns} dataSource={data_table} />
      </div>
    </div>
  );

};